import { render, staticRenderFns } from "./StockProductHistory.vue?vue&type=template&id=8d1f850a&"
import script from "./StockProductHistory.vue?vue&type=script&lang=js&"
export * from "./StockProductHistory.vue?vue&type=script&lang=js&"
import style0 from "./StockProductHistory.vue?vue&type=style&index=0&id=8d1f850a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports